import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    // Load Meta Pixel script
    !function (f: any, b: any, e: string, v: string, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
    // Initialize pixel
    ;
    (window as any).fbq('init', '1423074459182335')
    // 1) PageView al entrar a la landing
    ;
    (window as any).fbq('track', 'PageView');
    console.log('✅ Meta Pixel loaded - ID: 1423074459182335');
    console.log('✅ PageView tracked');
    // 2) InitiateCheckout al hacer clic en el botón que lleva a Hotmart
    const checkoutButtons = document.querySelectorAll('.checkout-btn, .cta-button, a[href*="hotmart"], a[href*="checkout"], button[data-checkout], button:has(.lucide-download)');
    const handleCheckoutClick = () => {
      if (typeof (window as any).fbq === 'function') {
        ;
        (window as any).fbq('track', 'InitiateCheckout');
        console.log('✅ InitiateCheckout tracked');
      }
    };
    checkoutButtons.forEach(btn => {
      btn.addEventListener('click', handleCheckoutClick);
    });
    // Cleanup event listeners on unmount
    return () => {
      checkoutButtons.forEach(btn => {
        btn.removeEventListener('click', handleCheckoutClick);
      });
    };
  }, []);
  return <div className="w-full min-h-screen bg-cream-50" data-id="element-0">
      <SalesPage data-id="element-1" />
    </div>;
}